import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {AppComponent} from './app.component';
import {ToastrModule} from 'ngx-toastr';
import {ConfigurationService} from './services/configuration.service';
import {RequestsService} from './services/requests.service';
import {MainViewModule} from './components/main-view/main-view.module';
import {NavigationComponent} from './components/navigation/navigation.component';
import {Routing} from './app.routes';
import {DataPathUtils} from './utils/dataPath.utils';
import {MultipartFormUtils} from './utils/multipartForm.utils';
import {UrlUtils} from './utils/url.utils';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from "@angular/common/http";
import {AuthenticationService} from './services/authentication.service';
import {UploadFileServiceUtils} from './utils/uploadFileToS3.utils';
import {CommonUtils} from "./utils/common.utils";
import {S3Utils} from "./utils/s3.utils";
import { QuartzCronModule } from '@sbzen/ng-cron';
import {MatIconModule} from "@angular/material/icon";
import {DialogService} from "./services/dialog.service";
import {MatDialogModule} from "@angular/material/dialog";
@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    Routing,
    MainViewModule,
    QuartzCronModule,
    MatIconModule,
    NoopAnimationsModule,
    MatDialogModule,
    ToastrModule.forRoot({
      timeOut: 10000
    })
  ],
  providers: [
    {provide: 'AuthenticationService', useClass: AuthenticationService},
    {provide: 'ConfigurationService', useClass: ConfigurationService},
    {provide: 'RequestsService', useClass: RequestsService},
    {provide: 'DataPathUtils', useClass: DataPathUtils},
    {provide: 'MultipartFormUtils', useClass: MultipartFormUtils},
    {provide: 'UploadFileServiceUtils', useClass: UploadFileServiceUtils },
    {provide: 'UrlUtils', useClass: UrlUtils},
    {provide: 'CommonUtils', useClass: CommonUtils},
    {provide: 'S3Utils', useClass: S3Utils},
    {provide: 'DialogService', useClass: DialogService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
